import { ChevronRight, HardDrive } from "lucide-react";

export const parentPath = (p) => (p && p.includes("/") ? p.slice(0, p.lastIndexOf("/")) : "");

export const lastSegment = (p) => (p && p.includes("/") ? p.slice(p.lastIndexOf("/") + 1) : p);

export function FolderBreadcrumb({ root, path, onNavigate, testidPrefix = "bc" }) {
  const segs = path ? path.split("/") : [];
  return (
    <nav className="flex flex-wrap items-center gap-1 text-sm" data-testid={`${testidPrefix}-breadcrumb`}>
      <button
        type="button"
        onClick={() => onNavigate("")}
        className={`flex items-center gap-1.5 rounded px-1.5 py-0.5 font-medium transition-colors ${segs.length === 0 ? "text-slate-900" : "text-sky-700 hover:bg-sky-50"}`}
        data-testid={`${testidPrefix}-breadcrumb-root`}
      >
        <HardDrive className="h-3.5 w-3.5" /> {root}
      </button>
      {segs.map((s, i) => {
        const target = segs.slice(0, i + 1).join("/");
        const isLast = i === segs.length - 1;
        return (
          <span key={target} className="flex items-center gap-1">
            <ChevronRight className="h-3.5 w-3.5 text-slate-300" />
            {isLast ? (
              <span className="rounded px-1.5 py-0.5 font-semibold text-slate-900" data-testid={`${testidPrefix}-breadcrumb-current`}>{s}</span>
            ) : (
              <button
                type="button"
                onClick={() => onNavigate(target)}
                className="rounded px-1.5 py-0.5 text-sky-700 transition-colors hover:bg-sky-50"
                data-testid={`${testidPrefix}-breadcrumb-seg-${i}`}
              >
                {s}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
}
